import { render, staticRenderFns } from "./myTasks.vue?vue&type=template&id=07f4f39e&"
import script from "./myTasks.vue?vue&type=script&lang=js&"
export * from "./myTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports